export default {
      id: "sales-menu-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#sales-menu-usage",
      toString: function () {
        return this.url;
      }
    }